/** A command of the composer's "/" (D7b): an action of Crowdex, not of the agent. */
export type ComposerCommand = {
  id: 'rewind' | 'branch' | 'review' | 'pr';
  name: string;
  description: string;
};

/** The commands, in the order "/" lists them, before the skills. */
export const COMPOSER_COMMANDS: readonly ComposerCommand[] = [
  {
    id: 'rewind',
    name: '/rewind',
    description: 'Go back to an earlier message and continue from there',
  },
  {
    id: 'branch',
    name: '/branch',
    description: 'Create a branch from the current changes',
  },
  { id: 'review', name: '/review', description: 'Open Review on the changes of this conversation' },
  { id: 'pr', name: '/pr', description: 'Open the pull request of this branch' },
];

/** The commands whose name or purpose matches what follows "/". */
export function filterComposerCommands(
  commands: readonly ComposerCommand[],
  query: string,
): readonly ComposerCommand[] {
  const needle = query.trim().toLowerCase();
  if (needle.length === 0) return commands;
  return commands.filter((command) =>
    `${command.name.slice(1)} ${command.description}`.toLowerCase().includes(needle),
  );
}
